import { createSlice } from '@reduxjs/toolkit'
import { fetchHouseByHouse } from '../fetch/search';
const housebyHouseSlice = createSlice({
  name: 'housebyhouse',
  initialState: {
    isLoading: false,
    value: [],
    isError: false,
    page:0,
    totalPages:0,
    totalCount: 0
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHouseByHouse.pending, (state, action) => {
      state.isLoading = true;
    })
    builder.addCase(fetchHouseByHouse.fulfilled, (state, action) => {
      state.isLoading = false;
      let data = action.payload;
      state.page = data.pageNumber;
      state.totalCount = data.totalCount;
      state.totalPages = data.totalPages;
      if (data.items && data.items.constructor === Array)
        state.value = data.items;
    })
    builder.addCase(fetchHouseByHouse.rejected, (state, action) => {
      state.isError = true;
    })
  },
  reducers: {
  }
})
export const selectHouseByHouse = (state) => state.housebyhouse.value

export const selectPage = (state) => state.housebyhouse.page
export const selectTotalCount = (state) => state.housebyhouse.totalCount
export const selectTotalPages = (state) => state.housebyhouse.totalPages

export const selectLoadingHouseByHouse = (state) => state.housebyhouse.isLoading

export default housebyHouseSlice.reducer

